module.exports = __webpack_public_path__ + "img/safety-tool-fmea-item2-1.74e6c7a2.png";